import amGestionLogo from '@/assets/images/am-gestion.png';
import { HOST_MB } from '@/lib/constants';
import usePageTitle from '@/hooks/use-page-title';

const Maintenance = () => {
    usePageTitle('Maintenance');

    const logo = HOST_MB === 43397 ? '/images/logo.svg' : amGestionLogo;

    return (
        <div className="flex items-center justify-center min-vh-100 px-4 py-12 text-center">
            <div style={{maxWidth: 560}}>
                <img
                    src={logo}
                    alt=""
                    className="block mx-auto mb-6"
                    style={{maxWidth: 220, width: '100%', height: 'auto'}}
                />

                <h1 className="h2 font-bold mb-4">
                    Votre espace personnel est en cours de <span className="text-[oklch(from_var(--color-primary)_calc(l*0.95)_c_h)]">maintenance</span>
                </h1>

                <p className="mb-2">
                    Nous améliorons votre espace personnel pour vous offrir une meilleure expérience.
                </p>
                <p className="mb-6">
                    Il sera de nouveau disponible très prochainement. Merci pour votre patience.
                </p>

                <button
                    type="button"
                    className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-[0.875rem]/5 font-medium rounded-md transition-all ease-[ease] cursor-pointer no-underline disabled:opacity-50 disabled:pointer-events-none bg-primary text-primary-foreground border-none hover:bg-primary-hover mb-12"
                    onClick={() => { window.location.href = '/' }}
                >
                    Je réessaye
                </button>

                <div className="border-t pt-6">
                    <p className="font-bold mb-4">Besoin d’aide immédiatement ?</p>
                    <p className="mb-2">
                        Numéro d’assistance&nbsp;:{' '}
                        <a href="tel:+33149936582" className="font-bold">01.49.93.65.82</a>
                    </p>
                    <p className="mb-0">
                        Notre email&nbsp;:{' '}
                        <a href="mailto:moncontrat@april-moto.com" className="font-bold">moncontrat@april-moto.com</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Maintenance;
